import React, { useState } from 'react'
import PropTypes from 'prop-types'
import { useSelector, useDispatch } from 'react-redux'
import { setLoginModalOpen } from 'store/auth'
import LogoLink from 'components/logoLink'
import { UserCircleIcon } from 'components/icons'
import CustomerProfilemodal from 'components/modals/CustomerProfileModal'
import NotificationsPopover from './popovers/NotificationsPopover'
import classNames from 'classnames'
import { getProfileImage } from 'data/helpers/users'

const FixedNavbar = ({
  children,
  columnOneChildren,
}) => {
  const dispatch = useDispatch()

  const [profileModalOpen, setProfileModalOpen] = useState(false)

  const { user, checked } = useSelector(state => ({
    user: state.auth.user,
    checked: state.auth.checked,
  }))

  return (
    <div className="fixed top-0 z-30 w-full bg-white shadow-public-searchbar">
      <div className={classNames(
        'items-center w-full grid-cols-3 h-80 md:px-40 gap-x-20',
        {
          'flex xl:grid': columnOneChildren,
          'grid': !columnOneChildren,
        },
      )}>
        <div className="flex items-center xl:gap-x-60 gap-x-20">
          <LogoLink className="w-full h-55 max-w-[101px] min-w-[101px]" />

          {columnOneChildren}
        </div>

        <div className="flex justify-center w-full mx-auto gap-55">
          {children}
        </div>

        <div className="flex items-center justify-end border-none cursor-pointer xl:w-full gap-15 text-30 whitespace-nowrap px-15">
          {
            checked && user
              ? <div className="flex items-center gap-30" >
                <NotificationsPopover />

                <button className="flex items-center gap-15" onClick={() => setProfileModalOpen(true)}>
                  <p className="uppercase text-grey text-14">{user.first_name}</p>
                  {
                    getProfileImage(user)
                      ? <img src={getProfileImage(user)} className="rounded-full h-30 w-30" />
                      : <UserCircleIcon />
                  }
                </button>
              </div>
              : <button className="flex items-center" onClick={() => dispatch(setLoginModalOpen(true))}>
                <p className="uppercase text-14 text-grey-800 mr-18">Login</p>
                <UserCircleIcon />
              </button>
          }
        </div>
      </div>
      <CustomerProfilemodal isOpen={profileModalOpen} onClose={() => setProfileModalOpen(false)} />
    </div>
  )
}

FixedNavbar.propTypes = {
  children: PropTypes.node,
  columnOneChildren: PropTypes.node,
}

export default FixedNavbar
